import { observer } from "mobx-react-lite";
import { useVideoStore } from "../../../../../../shared/hooks/useVideoStore";
import {
    BottomSC,
    ButtonTextSC,
    ContextSC,
    GenerateSC,
    LeftSC,
    PromptSC,
} from "./styled";
import { CopyIcon } from "../../../../assests/icons/CopyIcon";
import { UpdateIcon } from "../../../../assests/icons/UpdateIcon";
import { ArrowFIcon } from "../../../../assests/icons/ArrowFIcon";

export const Context = observer(() => {
    const videoStore = useVideoStore();

    const handleEditFrame = () => {
        alert("Edit Frame: This would navigate to a frame editor page");
        videoStore.hideContextMenu();
    };

    const handleEditVideo = () => {
        alert("Edit Video: This would navigate to a video editor page");
        videoStore.hideContextMenu();
    };

    return (
        <ContextSC>
            <PromptSC>{text}</PromptSC>
            <BottomSC>
                <LeftSC>
                    <CopyIcon />
                    <UpdateIcon />
                </LeftSC>
                <GenerateSC>
                    <ButtonTextSC>Generate</ButtonTextSC>
                    <ArrowFIcon />
                </GenerateSC>
            </BottomSC>
        </ContextSC>
    );
});

export const text =
    "Create a photorealistic image in the exact same 3D rendered style as the reference images —\n" +
    "Ultra-HD 3D, Hyper-Realistic, bright saturated cinematic sunlight.\n" +
    "Use the same young man and the same young woman as in the reference images.\n" +
    "Setting:\n" +
    "Luxury tropical resort suite bedroom, bright sunny afternoon. The bedroom is elegant and peaceful, with soft natural light filtering through sheer white curtains. Through the partially open balcony doors, glimpses of palm fronds and tropical greenery are visible. The room features a large comfortable bed with crisp white linens and a light beige throw blanket. The atmosphere is tranquil, intimate, and filled with gentle afternoon warmth.\n" +
    "Main Couple (3/4 view, near full-body):\n" +
    "\n" +
    "Young Man:\n" +
    "Clothing: White t-shirt, light gray lounge shorts.\n" +
    "Pose & Expression: Lying on his side on the bed, eyes closed, peaceful and relaxed. His body is partially covered by a light blanket, one arm tucked under the pillow. His face shows complete trust and serenity — he's resting after lunch, comfortable and at peace.\n" +
    "\n" +
    "Young Woman:\n" +
    "Clothing: Soft pastel sundress (light pink or peach).\n" +
    "Pose & Expression: Standing beside the bed, leaning forward gently.\n" +
    "– Right hand: Carefully adjusting the blanket over his shoulders, pulling it up to cover him better.\n" +
    "– Left hand: Tenderly stroking his hair, fingers running softly through it.\n" +
    "Her expression is loving, patient, and caring — no";
